<mp-avatar [name]="userName()" [image]="image()" size="tiny" />

<div class="user-info">
  <span class="user-info__name">{{ userName() }}</span>
  <span class="user-info__organization">{{ organizationName() }}</span>
</div>
